import { createElement } from "react";

import useUpdate from "@/hooks/use-update";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { userService } from "@/services/user.service";

export type UpdateUserProps = {
  formData: Record<string, unknown>;
  _id: number;
  errorMessage?: string;
  onSuccess?: () => void;
};

export type UseUpdateUserReturn = {
  update: (props: UpdateUserProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateUser = (): UseUpdateUserReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<
    Record<string, unknown>
  >({
    operation: async (formData, _id) => {
      await userService.update(_id, formData);
    },
  });

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateUser;
